/**
 * MobileTabBar
 * Version-gated: v2 renders the classic 4+More mobile tab bar,
 * v3 renders the 6-tab Excel worksheet BottomSheetTabs.
 *
 * v2: Visible only on viewports below the md breakpoint.
 * v3: Visible on all viewports (desktop 34px, mobile 40px).
 *     Controlled by PanelContext.bottomVisible — the bottom panel
 *     toggle in ScrollableTitleRow shows/hides the tabs.
 */

import { isV3 } from '../../hooks/useDesignVersion';
import { MobileTabBarV2 } from './MobileTabBarV2';
import { BottomSheetTabs } from './BottomSheetTabs';
import { usePanels } from '../../contexts/PanelContext';

export function MobileTabBar() {
  if (isV3()) {
    return <MobileTabBarV3 />;
  }
  return <MobileTabBarV2 />;
}

/** v3 wrapper — reads bottomVisible from PanelContext */
function MobileTabBarV3() {
  const { bottomVisible } = usePanels();
  if (!bottomVisible) return null;
  return <BottomSheetTabs />;
}
